import {useTranslation} from 'react-i18next';
import Timeline from '../../../timeline/Timeline';
import * as css from './ValidityAndTimesSection.css';

export const timelinePoints = [
    {
        dateFieldPath: 'saleStartDate',
        timeFieldPath: 'saleStartTime',
        label: 'saleStartDate'
    },
    {
        dateFieldPath: 'saleEndDate',
        timeFieldPath: 'saleEndTime',
        label: 'saleEndDate',
        showDuration: true
    },
    {
        dateFieldPath: 'redemptionEndDate',
        timeFieldPath: 'redemptionEndTime',
        label: 'redemptionEndDate',
        showDuration: true
    }
];

function ValidityAndTimesSection() {
    const {t} = useTranslation('subscriptions');

    return (
        <>
            <css.validityHeader>
                <css.validityTitle>{t('validityAndTimes')}</css.validityTitle>
                <css.lifecycleSubtitle>{t('subscriptionLifecycleBar')}</css.lifecycleSubtitle>
            </css.validityHeader>
            <css.timeLineSection>
                <Timeline points={timelinePoints} />
            </css.timeLineSection>
        </>
    );
}

export default ValidityAndTimesSection;

